<template>
  <div>
    <!--普通文字按钮，背景按钮-->
    <div
      v-if="!isBindWX && model == 'switch'"
      :class="{ 'bind-wrapper': showBackground }"
    >
      <span class="m-r-12 font-14">{{ descText }}</span>
      <el-button type="text" class="p-v-0" @click="showDialog = true">
        立即关注<i class="el-icon-arrow-right"></i>
      </el-button>
    </div>

    <!--工作台的icon形式按钮-->
    <div
      v-if="model == 'wx-icon' && !isBindWX"
      class="wx-icon no-bind m-l-6  text-cursor"
      @click="showDialog = true"
    >
      <i class="iconfont icon--_weixin icon m-r-5"></i>
      <span class="text">未绑定</span>
    </div>
    <div v-if="model == 'wx-icon' && isBindWX" class="wx-icon bind m-l-6">
      <i class="iconfont icon--_weixin icon m-r-5"></i>
      <span class="text">已绑定</span>
    </div>

    <!--微信扫码弹窗-->
    <el-dialog :visible.sync="showDialog" :append-to-body="true" width="400px">
      <div class="flex-col flex-center">
        <div>微信扫码关注“精彩纵横”公众号，接受通知</div>

        <div class="bind-img-wrapper m-t-20">
          <!--绑定图片展示-->
          <el-image
            v-loading="loading"
            :src="bindUrl"
            @click.native="getBindQrCode"
          >
            <template slot="error">
              <div class="img-error flex-col flex-center">
                <i class="el-icon-refresh-right"></i>
                <div class="m-t-10">点击重新获取二维码</div>
              </div>
            </template>
          </el-image>

          <!--绑定成功遮罩-->
          <div
            v-if="showSuccessCover"
            class="success-mask flex-col flex-center"
          >
            <i class="iconfont icon--_check-circle-fill"></i>
            <div>绑定成功</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 接口api
import { getBindWechatQrCodeApi } from '@/api/user.js'

// 工具函数
import { mapActions, mapState } from 'vuex'

export default {
  name: 'WeChatBindDialog',

  props: {
    descText: {
      type: String,
      default: '扫码关注微信公众号，获取供应商报名最新消息'
    },
    model: {
      type: String,
      default: 'switch'
    },
    showBackground: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      showDialog: false,

      // 微信绑定信息
      showSuccessCover: false, // 绑定成功显示
      bindUrl: '', // 二维码链接地址
      ticket: '', // 凭证信息

      // 定时器
      timer: null
    }
  },

  computed: {
    ...mapState('user', ['isBindWX'])
  },

  watch: {
    showDialog(val) {
      val && this.getBindQrCode()
    }
  },

  beforeDestroy() {
    this.timer && clearTimeout(this.timer)
  },

  methods: {
    // 获取用户信息
    ...mapActions('user', ['getEmployeeInfo']),

    // 获取绑定微信的二维码
    getBindQrCode() {
      this.loading = true

      getBindWechatQrCodeApi()
        .then(res => {
          this.bindUrl = res.data?.url || ''
          this.ticket = res.data?.ticket || ''

          this.getWechatBindStatus()
        })
        .catch(err => {
          this.$message.error(err.data.message || '获取二维码失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 获取微信公众号绑定状态
    getWechatBindStatus() {
      this.timer && clearTimeout(this.timer)

      this.getEmployeeInfo(false)
        .then(res => {
          if (res?.userInfo?.wxMpOpenid) {
            this.showSuccessCover = true
            setTimeout(() => {
              this.showDialog = false
            }, 1000)
          } else {
            this.timer = setTimeout(() => this.getWechatBindStatus(), 1000)
          }
        })
        .catch(err => {
          this.timer = setTimeout(() => this.getWechatBindStatus(), 1000)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.bind-wrapper {
  padding: 6px 10px;
  background-color: $primary-fourth-color;
}

.bind-img-wrapper {
  position: relative;
  width: 150px;
  height: 150px;

  .success-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    color: $white-color;

    i {
      font-size: 40px;
      color: $success-color;
    }
  }
}

::v-deep .img-error {
  width: 150px;
  height: 150px;
  cursor: pointer;

  &:hover {
    color: $primary-color;
  }

  i {
    font-size: 24px;
  }
}

.wx-icon {
  border-radius: 4px;
  box-sizing: border-box;
  padding: 2px 8px 0px 8px;
  font-size: 12px;
  display: flex;
  align-items: center;

  &.no-bind {
    background: $third-text-color;
    .icon {
      color: $white-color;
    }
    .text {
      color: $white-color;
    }
  }
  &.bind {
    background: $white-color;
    border: 1px solid $info-third-color;
    .icon {
      color: $success-color;
    }
    .text {
      color: $text-color;
    }
  }
}
</style>
